import {getUserMedal} from '@/api/medal';
import {getBaseInfoListByCreatorId} from '@/api/resume';
import {findRecommendJob} from '@/api/job'

const state = {
    userSkill: [],
    baseInfoList: [],
    recommendJobList: []
}

// getters
const getters = {};

const actions = {
    /** 获取个人技能标签*/
    getUserSkill({state, commit}) {
        return new Promise((resolve, reject) => {
            if(state.userSkill.length > 0){
                return;
            }
            getUserMedal().then((res) => {
                commit("SET_USER_SKILL", res.data);
                resolve(res);
            });
        });
    },
    /** 获取简历列表*/
    getBaseInfoList({state, commit}) {
        return new Promise((resolve, reject) => {
            getBaseInfoListByCreatorId().then((res) => {
                commit("SET_BASE_INFO_LIST", res.data);
                resolve(res);
            });
        });
    },
    /** 获取推荐职位 */
    getRecommendJobList({state, commit}) {
        return new Promise((resolve, reject) => {
            findRecommendJob().then((res) => {
                commit("SET_RECOMMEND_JOB_LIST", res.data);
                resolve(res);
            })
        });
    },
};

// mutations
const mutations = {
    /** 设置个人技能标签*/
    SET_USER_SKILL(state, list) {
        state.userSkill = list;
    },
    /** 设置个人简历列表*/
    SET_BASE_INFO_LIST(state, list) {
        for (let i in list) {
            // 格式化简历基础信息
            list[i].city = JSON.parse(list[i].city);
            list[i].address = JSON.parse(list[i].address);
            list[i].expectIndustry = JSON.parse(list[i].expectIndustry);
            list[i].expectPosition = JSON.parse(list[i].expectPosition);
            // 格式化简历工作经历
            for (let j in list[i].workExperienceList) {
                list[i].workExperienceList[j].industry = JSON.parse(list[i].workExperienceList[j].industry);
            }
        }
        state.baseInfoList = list;
    },
    SET_RECOMMEND_JOB_LIST(state, list) {
        list.forEach((item, index) => {
            item.industry = JSON.parse(item.industry);
            item.enterpriseCity = JSON.parse(item.enterpriseCity);
        });
        state.recommendJobList = list;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
